import { gaEvent } from 'utils/ga'
import * as providers from './provider'

export default setRoot => {
  const setError = error =>
    setRoot(prev => ({
      ...prev,
      error,
    }))

  const sendEmail = async (email, checkOffers, checkOffersResale) => {
    setRoot(prev => ({
      ...prev,
      sendLeadEmailLoading: true,
    }))

    const [err] = await providers.sendEmail(
      email,
      checkOffers,
      checkOffersResale
    )

    if (err) {
      return setRoot(prev => ({
        ...prev,
        sendLeadEmailError: true,
        sendLeadEmailLoading: false,
      }))
    }
    gaEvent({
      category: 'L_Lead_Home',
      action: 'submit',
    })

    return setRoot(prev => ({
      ...prev,
      sendLeadEmailLoading: false,
    }))
  }

  const setField = (value, field) =>
    setRoot(prev => ({
      ...prev,
      [field]: value,
    }))

  const setCookies = cookies => {
    setRoot(prev => ({
      ...prev,
      cookies,
    }))
  }

  const setLeadModal = leadModalStatus => {
    setRoot(prev => ({
      ...prev,
      leadModal: leadModalStatus,
    }))
  }

  const setActiveTerm = term => {
    setRoot(prev => ({
      ...prev,
      activeTerm: term,
    }))
  }

  return {
    setError,
    sendEmail,
    setCookies,
    setLeadModal,
    setActiveTerm,
    setField,
  }
}
